import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "item", "divider"]

  connect() {
    console.log("archive-sort controller connected", this.itemTargets.length, "items")
    this.sort()
  }

  toggle(event) {
    console.log("archive-sort toggle called")
    // Delay to let checkbox state update
    setTimeout(() => this.sort(), 50)
  }

  sort() {
    const container = this.containerTarget
    const items = Array.from(this.itemTargets)
    const divider = this.dividerTarget

    if (!container || items.length === 0) {
      console.log("archive-sort: no container or items")
      return
    }

    // Separate enabled and disabled items
    const enabled = []
    const disabled = []

    items.forEach(item => {
      const checkbox = item.querySelector('input[type="checkbox"]')
      if (checkbox && checkbox.checked) {
        enabled.push(item)
      } else {
        disabled.push(item)
      }
    })

    console.log("archive-sort: enabled=", enabled.length, "disabled=", disabled.length)

    // Remove all items from container
    items.forEach(item => {
      if (item.parentNode) item.parentNode.removeChild(item)
    })
    if (divider && divider.parentNode) divider.parentNode.removeChild(divider)

    // Re-add enabled items first
    enabled.forEach((item, index) => {
      item.classList.remove('border-top')
      if (index > 0) {
        item.classList.add('border-top')
      }
      container.appendChild(item)
    })

    // Add divider if there are disabled items
    if (disabled.length > 0 && divider) {
      divider.classList.remove('d-none')
      container.appendChild(divider)

      // Add disabled items
      disabled.forEach((item) => {
        item.classList.remove('border-top')
        item.classList.add('border-top')
        container.appendChild(item)
      })
    } else if (divider) {
      divider.classList.add('d-none')
    }
  }
}

